// extracted by mini-css-extract-plugin
export var backupIcon = "_sd-1";
export var image = "_sd-0";